module.exports = __webpack_public_path__ + "media/images/flags/64/Costa-Rica-3426ea396758377a8b44d075ee5ade29.png";